import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {store} from './app/store';
import './Apps.scss';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from "react-bootstrap"
import {RouterProvider} from "react-router-dom";
import "./Apps.scss"
import './index.scss';
import 'bootstrap/scss/bootstrap.scss';
import {router} from "./router";


const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider
                breakpoints={['xl', 'lg', 'md', 'xs']}
                minBreakpoint="xs"
            >
                <RouterProvider router={router} />
            </ThemeProvider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
